var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChassis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49414,68.75H70.50586a.7502.7502,0,0,0,.75-.75V12a.7502.7502,0,0,0-.75-.75H9.49414a.7502.7502,0,0,0-.75.75V68A.7502.7502,0,0,0,9.49414,68.75Zm31.61816-56H69.75586v12.5H41.1123Zm0,14H69.75586v12.5H41.1123Zm0,14H69.75586v12.5H41.1123Zm0,14H69.75586v12.5H41.1123Zm-30.86816-42H39.6123v12.5H10.24414Zm0,14H39.6123v12.5H10.24414Zm0,14H39.6123v12.5H10.24414Zm0,14H39.6123v12.5H10.24414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChassis);
export default __webpack_public_path__ + "static/media/icon_chassis.272a2d80889791e5b147a91f2d07be73.svg";
export { ForwardRef as ReactComponent };